import { registerNodeType } from '../../registry'
import { ICONIFY } from '../../../../../Constants/iconify'
import CheckboxNode from './CheckboxNode'
import CheckboxConfig from './CheckboxConfig'

registerNodeType({
  type: 'CHECKBOX',
  label: 'Checkbox',
  icon: ICONIFY.CHECKBOX,
  color: '#4CAF50',
  hasOptions: true,
  excludeFields: ['inputMode', 'inputRegex'],
  defaults: { minSize: 1, answerOptionList: null },
  nodeComponent: CheckboxNode,
  configComponent: CheckboxConfig,
})
